import { render, staticRenderFns } from "./BackAboutUs.vue?vue&type=template&id=1b046b90&scoped=true"
import script from "./BackAboutUs.vue?vue&type=script&lang=js"
export * from "./BackAboutUs.vue?vue&type=script&lang=js"
import style0 from "./BackAboutUs.vue?vue&type=style&index=0&id=1b046b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b046b90",
  null
  
)

export default component.exports